import React from 'react';
import GenAIOpsOverviewHelp from './GenAIOpsOverviewHelp';
import ObservabilityHelp from './ObservabilityHelp';
import RegistryHelp from './RegistryHelp';
import EvaluationHelp from './EvaluationHelp';
import GovernanceHelp from './GovernanceHelp';

interface GenAIOpsHelpProps {
  activeTab?: string;
  activeSubTab?: string;
}

/**
 * GenAIOps Help - Context-aware help content switcher
 */
const GenAIOpsHelp: React.FC<GenAIOpsHelpProps> = ({ activeTab, activeSubTab }) => {
  switch (activeTab) {
    case 'overview':
      return <GenAIOpsOverviewHelp />;
    case 'observability':
      return <ObservabilityHelp subTab={activeSubTab} />;
    case 'registry':
      return <RegistryHelp subTab={activeSubTab ?? ''} />;
    case 'evaluation':
      return <EvaluationHelp subTab={activeSubTab ?? ''} />;
    case 'governance':
      return <GovernanceHelp subTab={activeSubTab ?? ''} />;
    default:
      return <GenAIOpsOverviewHelp />;
  }
};

export default GenAIOpsHelp;
